module.exports = __webpack_public_path__ + "static/media/electrodomesticos.a7b24e24.svg";